import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/Home';
import './Home.css';

class Home extends Component {
    
    componentWillMount() {
        // This method runs when the component is first added to the page
        this.props.history.push('/');
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    render() {
        return (
            <div>
                <h1>Empire Paper Company</h1>
                <p>Welcome to Empire Paper's Sales Portal. Internal use only.</p>
            </div>
        );
    }
}

export default connect(
    state => state.home,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.js